import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqGroup } from "../types";

export const getFaqGroupDetails = async (
  faqGroupId: string,
): Promise<FaqGroup | null> => {
  const collectionRef = collection(db, "faqGroups");
  const faqGroupSnap = await getDoc(doc(collectionRef, faqGroupId));

  if (!faqGroupSnap.exists()) {
    return null;
  }
  return { ...faqGroupSnap.data(), id: faqGroupSnap.id } as FaqGroup;
};
